module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_1500_Inactive@1x-0efb9f7b4c7bf316f6c2379e569305b7.png";